<template>
  <div>
    <the-home-header />
    <div class="animationFix">
      <slot />
    </div>
    <the-footer />
  </div>
</template>
<script>
import TheHomeHeader from '../components/Common/TheHomeHeader';
import TheFooter from '../components/Common/TheFooter';
export default {
  components: {
    TheHomeHeader,
    TheFooter
  }
}
</script>